import { NativeStackScreenProps } from "@react-navigation/native-stack";
import {
  ManageLocationsRootParamList,
  LocationFormParamList,
} from "../../../../types";
import {
  createStackHeaderNavigator,
  ModalCloseButton,
} from "@towersystems/roam-common-native";
import { LocationFormScreen } from "./LocationFormScreen";
import React from "react";
import { Location } from "@towersystems/roam-common/lib/generated-types";
import { useLazyQuery } from "@apollo/client";
import { QUERY_LOCATION } from "../../common";
import { LocationForm } from "../../components/LocationForm";

const Stack = createStackHeaderNavigator<LocationFormParamList>();

export type EditLocationScreenProps = NativeStackScreenProps<
  ManageLocationsRootParamList,
  "EditLocationScreen"
>;

export const EditLocationScreen = ({
  navigation,
  route,
}: EditLocationScreenProps) => {
  const [location, setLocation] = React.useState<Location | undefined>(
    undefined
  );

  const { locationId } = route.params;

  const [q] = useLazyQuery<{
    location: Location;
  }>(QUERY_LOCATION);

  React.useEffect(() => {
    if (locationId) {
      q({
        variables: { id: locationId },
      })
        .then((result) => {
          if (result.data?.location) {
            setLocation(result.data.location);
          } else {
            navigation.goBack();
          }
        })
        .catch(() => {
          navigation.goBack();
        });
    } else {
      navigation.goBack();
    }
  }, [locationId]);

  if (!location) {
    return null; // or a loading indicator
  }

  return (
    <LocationForm
      defaultFormValues={{
        id: location.id,
        name: location.name,
        enabled: location.enabled,
        retailerLocationKey: location.retailerLocationKey,
      }}
    >
      <Stack.Navigator
        screenOptions={{
          animationEnabled: true,
          headerShown: true,
          headerLeft: () => <ModalCloseButton type="Back" />,
          title: "",
          headerStyle: {
            backgroundColor: "transparent",
          },
          headerBackgroundContainerStyle: {
            backgroundColor: "transparent",
          },
        }}
      >
        <Stack.Group>
          <Stack.Screen
            name="LocationFormScreen"
            component={LocationFormScreen}
          />
        </Stack.Group>
      </Stack.Navigator>
    </LocationForm>
  );
};
